import { useState } from 'react';
import { motion } from 'framer-motion';
import { PROJECTS } from './data';

// PROJECTS — strict 12-col grid. Each project gets a single hero image with
// data table beneath. Filter by typology pills on top.
export default function Projects({ setPage }) {
  const cats = ['All', ...new Set(PROJECTS.map(p => p.cat))];
  const [cat, setCat] = useState('All');
  const list = cat === 'All' ? PROJECTS : PROJECTS.filter(p => p.cat === cat);
  return (
    <div className="bg-[#DADCD6] text-[#1B1A18]">
      {/* Lead */}
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-6 lg:px-12 border-b border-[#1E3A5F]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1E3A5F] mb-4">/ Index 02 · Built projects</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.025em] text-[#1E3A5F]">Thirty-eight projects, <span className="italic">drawn carefully</span>.</h1>
      </section>

      {/* Filter rail */}
      <div className="sticky top-16 z-30 bg-[#DADCD6] border-b border-[#1E3A5F]/15">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-3 flex flex-wrap items-center gap-2 font-mono text-[10px] tracking-[0.22em] uppercase">
          <span className="text-[#1E3A5F]/45 mr-2">Typology</span>
          {cats.map(c => (
            <button key={c} onClick={() => setCat(c)} data-testid={`arch-cat-${c}`}
              className={`px-3 py-1.5 transition-colors ${cat === c ? 'bg-[#1E3A5F] text-[#E5C61F]' : 'border border-[#1E3A5F]/20 text-[#1B1A18]/65 hover:border-[#1E3A5F]'}`}>
              {c}
            </button>
          ))}
        </div>
      </div>

      <section className="max-w-[1500px] mx-auto px-6 lg:px-12 py-12 space-y-20">
        {list.map((p, i) => (
          <motion.article key={p.code} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
            className="grid grid-cols-12 gap-4 lg:gap-6">
            <div className="col-span-12 lg:col-span-8">
              <div className="aspect-[16/9] overflow-hidden bg-[#1E3A5F]/10"><img src={p.img} alt="" className="w-full h-full object-cover" loading="lazy" /></div>
            </div>
            <div className="col-span-12 lg:col-span-4">
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1E3A5F]">/ {p.code} · {p.cat}</p>
              <h2 className="font-serif text-3xl lg:text-5xl mt-3 leading-[1] text-[#1E3A5F]" dangerouslySetInnerHTML={{ __html: p.t }} />
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#1B1A18]/55 mt-2">{p.loc}</p>
              <table className="font-mono text-[11px] mt-6 w-full">
                <tbody>
                  {[['GFA', p.sqm + ' m²'], ['Year', p.yr], ['Typology', p.cat], ['Status', i === 2 ? 'On site' : 'Completed']].map(([k, v]) => (
                    <tr key={k} className="border-b border-[#1E3A5F]/15">
                      <td className="py-2 text-[#1E3A5F]/55 tracking-[0.2em] uppercase w-20">{k}</td>
                      <td className="py-2 text-[#1B1A18]">{v}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <p className="font-serif text-base text-[#1B1A18]/85 mt-5 leading-[1.65]" dangerouslySetInnerHTML={{ __html: p.brief }} />
              <button onClick={() => setPage('commission')} className="mt-6 font-mono text-[10px] tracking-[0.3em] uppercase border-b border-[#1E3A5F] text-[#1E3A5F] pb-1 hover:text-[#E5C61F] hover:border-[#E5C61F]" data-testid={`arch-project-${p.code}`}>Discuss similar →</button>
            </div>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
